import React from 'react';
import WithSection from '../../components/WithSection/WithSection';
import { graphql } from 'gatsby';
import Box from '../../components/Box/Box';
import { Body1, Head3 } from '../../components/Typography/Typography';
import { rem } from 'polished';
import { DownloadForm } from '../../components/DownloadForm';

const DownloadFormSection = ({
    data,
    styling: { backgroundVariant: sectionBackground },
}) => {
    const {
        primary: {
            download_form,
            download_form_section_description,
            download_form_section_heading,
        },
    } = data;

    return (
        <>
            <Box
                gridColumn={{
                    _: '1/-1',
                    md: '1/span 4',
                    lg: '2/span 4',
                    xl: '3/span 4',
                }}
            >
                <Head3 py={rem(8)}>{download_form_section_heading}</Head3>
                <Body1 py={rem(8)} mt={rem(8)}>
                    {download_form_section_description}
                </Body1>
            </Box>
            <Box
                gridColumn={{
                    _: '1/-1',
                    md: '5/span 4',
                    lg: '7/span 5',
                    xl: '7/span 4',
                }}
                mt={{
                    _: rem(32),
                    md: 'initial',
                }}
            >
                <DownloadForm data={download_form.document.data} />
            </Box>
        </>
    );
};

export default WithSection(DownloadFormSection);

export const _ = graphql`
    fragment DOWNLOAD_FORM_SECTION on PrismicSectionDataBodyDownloadSection {
        id
        primary {
            download_form_section_heading
            download_form_section_description
            download_form {
                document {
                    ... on PrismicDownloadForm {
                        id
                        data {
                            file_to_be_downloaded {
                                document {
                                    __typename
                                    ... on PrismicPage {
                                        data {
                                            slug
                                        }
                                    }
                                    ... on PrismicSection {
                                        uid
                                    }
                                }
                                type
                                url
                                target
                            }
                            form {
                                type
                                id
                                document {
                                    ... on PrismicDynamicForm {
                                        id
                                        data {
                                            cta_text
                                            fields {
                                                key
                                                is_required
                                                label
                                                options
                                                placeholder
                                                type
                                            }
                                            submit_url
                                            success_msg
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
